import styled from 'styled-components';

export default styled.div`
  && {
    background-color: rgba(193, 225, 141, 1);
    padding: 0 40px 25px 40px;
    .detail {
      background-color: white;
      height: 100%;
      width: 100%;
      border-radius: 10px;
      padding: 18px 25px 0 25px;
      .mr-23 {
        margin-right: 23px !important;
      }
      .mr-37 {
        margin-right: 37px !important;
      }
      .input-search-date {
        height: 40px;
      }
      .input-search-unit {
        height: 40px;
      }
      .icon {
        width: 15px;
        height: 15px;
      }
      .input-search-stk {
        height: 40px;
      }
      .ant-col-offset-2 {
        padding-top: 70px;
      }
      .search {
        display: flex;
        align-items: center;
        .icon1 {
          margin-bottom: 20px;
          margin-right: 8px;
        }
        p {
          margin-bottom: 20px;
          margin-right: 10px;
        }
      }
      .wrap-btn-search {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: center;
      }
      .btnSearch {
        height: 40px;
        width: 173px;
      }
      .backSetup {
        margin-right: 10px;
        width: 80px;
        height: 40px;
        background-color: #c4c4c4;
        color: white;
        border-radius: 5px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
        :hover {
          border: 1px solid #c4c4c4;
        }
      }
    }
  }
`;
